import { UniqueIdentifier } from '@givebutter/primitives/draggable';
import { taskStatuses } from 'components/tasks/utils/useTaskForm';
import { Task } from 'types/domain';

type SortableItems = Record<string, UniqueIdentifier[]>;

const findSortableContainer = (id: UniqueIdentifier, items: SortableItems) => {
    if (items.hasOwnProperty(id)) return id;
    for (const [key, value] of Object.entries(items)) {
        if (value.find(v => v === id)) return key;
    }
};

const transformTasksToGroups = (tasks: Task[]) => {
    const items: SortableItems = {};
    for (const status of taskStatuses) {
        items[status.id] = [];
    }
    for (const task of tasks) {
        if (items.hasOwnProperty(task.status)) {
            items[task.status].push(task.id);
        } else {
            items[task.status] = [task.id];
        }
    }
    return items;
};

export { findSortableContainer, transformTasksToGroups };
export type { SortableItems };
